<template>
  <v-flex class="about">
    <v-layout align-center>
      <v-btn
        class="mr-3 pr-1"
        dark
        fab
        small
        color="info"
        @click="$router.go(-1)"
      >
        <v-icon dark>chevron_left</v-icon>
      </v-btn>
      <h1>
        Bookings: <span class="font-weight-regular">{{ roomName }}</span>
      </h1>
      <v-spacer />
      <new-booking :roomid="$route.params.roomid" :room-name="roomName" />
    </v-layout>
    <v-card>
      <v-list v-if="loaded" two-line class="mt-3 pt-0 pb-0">
        <template v-for="(booking, index) in bookings">
          <v-list-item :key="booking.id">
            <v-layout align-center>
              <v-icon color="primary" class="mr-2">calendar_today</v-icon>
              {{ getDate(booking.start_timestamp) }}
              <v-icon color="primary" class="ml-5 mr-2">access_time</v-icon>
              {{ getTime(booking.start_timestamp) }} -
              {{ getTime(booking.end_timestamp) }}
              <v-icon
                v-if="getName(booking.booked_for)"
                color="primary"
                class="ml-5 mr-1"
                >person</v-icon
              >
              {{ getName(booking.booked_for) }}
              <v-icon
                v-if="
                  booking.booked_for.business.businessName ||
                    booking.booked_for.business.name
                "
                color="primary"
                class="ml-5 mr-1"
                >business_center</v-icon
              >
              {{
                booking.booked_for.business.businessName ||
                  booking.booked_for.business.name
              }}
            </v-layout>

            <v-list-item-action>
              <v-menu
                bottom
                left
                transition="slide-y-transition"
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on"> <v-icon>more_vert</v-icon> </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="openDeleteDialog(booking)">
                    <v-icon class="mr-2">delete</v-icon>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index + 1 < bookings.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
      <v-alert
        v-if="bookings.length === 0 && loaded"
        :value="true"
        type="info"
        color="primary"
        outlined
      >
        There are no bookings to display
      </v-alert>
    </v-card>

    <v-progress-linear
      v-if="!loaded"
      color="info"
      :indeterminate="true"
      class="mt-3"
    />

    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-app-bar flat dark color="primary">
          <v-toolbar-title>Are you sure?</v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          If you delete this booking it will be gone forever.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="loadingDelete" @click="deleteBooking()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { bookingsCollection, roomsCollection } from '../firebaseConfig.js';
import NewBooking from '@/components/NewBooking';
import moment from 'moment';

export default {
  name: 'Bookings',
  components: {
    NewBooking
  },
  data() {
    return {
      loaded: false,
      bookings: [],
      deleteDialog: false,
      currentBooking: null,
      roomName: '',
      loadingDelete: false
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    },
    currentTimestamp() {
      return Number(moment().format('X'));
    }
  },
  watch: {
    currentLocationId() {
      this.$router.push('meeting-rooms');
    }
  },
  mounted() {
    this.setRoomName();
    this.getBookings();
  },
  methods: {
    getDate(timestamp) {
      return moment(timestamp, 'X').format('ddd DD/MM/YYYY');
    },
    getName(user) {
      if (user.first_name && user.last_name) {
        return `${user.first_name} ${user.last_name}`;
      } else if (user.name) {
        return user.name;
      }
      return null;
    },
    getTime(timestamp) {
      return moment(timestamp, 'X').format('h:mma');
    },
    setRoomName() {
      this.roomName = this.$route.params.roomname || this.getRoomName();
    },
    getRoomName() {
      roomsCollection(this.currentLocationId)
        .doc(this.$route.params.roomid)
        .get()
        .then(room => {
          this.roomName = room.data().name;
        });
    },
    getBookings() {
      this.$bind(
        'bookings',
        bookingsCollection(this.currentLocationId, this.$route.params.roomid)
          .where('start_timestamp', '>=', this.currentTimestamp)
          .orderBy('start_timestamp')
      )
        .then(() => {
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading bookings: ${error}`
          });
        });
    },
    openDeleteDialog(booking) {
      this.currentBooking = booking;
      this.deleteDialog = true;
    },
    deleteBooking() {
      this.loadingDelete = true;
      bookingsCollection(this.currentLocationId, this.$route.params.roomid)
        .doc(this.currentBooking.id)
        .delete()
        .then(() => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'success',
            text: `Booking deleted successfully`
          });
        })
        .catch(error => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error deleting booking: ${error}`
          });
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
};
</script>
